/** Shared Streamdown / prose classes for assistant text in global Slick AI and
 * the driver-workspace AI column — keep them identical so the two surfaces
 * don't drift. */
export const AI_CHAT_PROSE_CLASS =
  "prose prose-base max-w-none leading-snug text-foreground dark:prose-invert prose-headings:text-base prose-headings:text-foreground prose-table:my-0 [&_p]:!my-3"
